"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const users_1 = require("./users");
exports.emailTemplateVersionDetails = graphql_tag_1.default `
  fragment emailTemplateVersionDetails on EmailTemplateVersion {
    id
    url
    version
    createdAt
    releaseNotes
    codePulledFrom
    html
    resourceUrl
    screenshot {
      id
      url
    }
    blocks {
      id
      name
    }
    creatingUser {
      ...basicUserDetailData
    }
    deployments {
      id
    }
    template {
      id
      name
      stagingVersion {
        screenshot {
          id
          url
        }
        id
        version
        resourceUrl
      }
      productionVersion {
        screenshot {
          id
          url
        }
        id
        version
        resourceUrl
      }
    }
  }
  ${users_1.basicUserDetailData}
`;
//# sourceMappingURL=emailTemplateVersions.js.map